@if (!isEditing) {
  <p class="flex items-center" [ngClass]="{'font-bold':isBold}">
    <span class="material-symbols-outlined text-sm cursor-pointer px-2" (click)="edit()">edit</span>
    {{value.Description}}
  </p>
}
@if (isEditing) {
  <div class="flex mt-2 mb-2 xl:w-2/3" >
    <select [(ngModel)]="value" [compareWith]="optionComparison" class="text-box">
      @for (t of options; track t) {
        <option [ngValue]="t" class="pr-20">{{t.Description}}</option>
      }
    </select>
    <p class= "right-0 flex items-center px-4">
      <span class="material-symbols-outlined text-green-300 cursor-pointer pr-2" (click)="confirm()">check</span>
      <span class="material-symbols-outlined text-danger-base cursor-pointer" (click)="revert()">close</span>
    </p>
  </div>
}
